import React from 'react';
import SkeletonPanel from './skeleton';
import Helpers from 'utils/helpers';
import './panel.css';

function Panel(props) {
  const getClass = () => {
    const classNames = ['panel', props.className];
    if (props.variant) {
      classNames.push(`panel-${props.variant}`);
    }
    if (Helpers.Object.exists(props.border)) {
      classNames.push('border');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()} style={props.style}>
      {props.children}
    </div>
  );
}

function PanelHeader(props) {
  const renderTools = () => {
    if (props.tools) {
      return (
        <div className='panel-header-tools'>{props.tools}</div>
      );
    }
    return null;
  }

  const getClass = () => {
    const classNames = ['panel-header', props.className];
    if (props.tools) {
      classNames.push('has-tools');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()} style={props.style}>
      <div className='panel-title'>{props.title || props.children}</div>
      {renderTools()}
    </div>
  );
}

function PanelFooter(props) {
  return (
    <div className={Helpers.String.join(['panel-footer', props.className])} style={props.style}>
      {props.children}
    </div>
  );
}

function PanelBody(props) {
  return (
    <div className={Helpers.String.join(['panel-body', props.className])} style={props.style}>
      {props.children}
    </div>
  );
}

Panel.Header = PanelHeader;
Panel.SkeletonHeader = SkeletonPanel.Header;
Panel.Footer = PanelFooter;
Panel.SkeletonFooter = SkeletonPanel.Footer;
Panel.Body = PanelBody;
Panel.SkeletonBody = SkeletonPanel.Body;

export default Panel;